import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import { Page404, BottomNavigation } from "components";
import {
  Main,
  Reports,
  Vehicles,
  Contacts,
  Setting,
  Account,
  Mailbox,
  Vaccines,
  TypeReports,
  SingleVaccine,
  ReportSuccess,
  Notifications,
  SinglePayment,
  SelectVehicles,
  SingleNotification,
  AddAndUpdateVehicle,
  SingleVaccineSchedule,
} from "pages/private";
import { TermsAndConditions, ResetPassword } from "pages/public";
import { loadScript, addFirtsChildDB } from "helpers";
import { askPermissionNotifications } from "config/index";
import { useGlobalContext } from "context/GlobalContext";
import { CDN_CONECKTA } from "constants/index";

const Dashboard = () => {
  const gContext = useGlobalContext();

  useEffect(() => {
    const loadScripts = async () => {
      try {
        await loadScript(CDN_CONECKTA);
        window.Conekta.setPublicKey("key_PDs3d8DZrxxRdaFxP1QY8Zw");
        window.Conekta.setLanguage("es");
      } catch (error) {
        console.log(error);
      }
    };

    const loadMessagingFirebase = async (id) => {
      const tokenWeb = await askPermissionNotifications();
      await addFirtsChildDB(`/TOKENS/${id}`, { "token-web": tokenWeb });
    };

    const id = gContext.currentUser?._id;
    id && loadMessagingFirebase(id);
    loadScripts();
  }, [gContext.currentUser]);

  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/">
            <Main />
          </Route>
          <Route path="/vacunas/horario/:id">
            <SingleVaccineSchedule />
          </Route>
          <Route path="/vacunas/pago/:id">
            <SinglePayment />
          </Route>
          <Route path="/vacunas/:id">
            <SingleVaccine />
          </Route>
          <Route path="/vacunas">
            <Vaccines />
          </Route>
          <Route path="/vehiculos/actualizar/:id">
            <AddAndUpdateVehicle />
          </Route>
          <Route path="/vehiculos/agregar">
            <AddAndUpdateVehicle />
          </Route>
          <Route path="/vehiculos">
            <Vehicles />
          </Route>
          <Route path="/denuncia-completada/:id">
            <ReportSuccess />
          </Route>
          <Route path="/denunciar/vehiculo/:car">
            <Reports />
          </Route>
          <Route path="/denunciar">
            <Reports />
          </Route>
          <Route path="/tipo-denuncia">
            <TypeReports />
          </Route>
          <Route path="/contactos">
            <Contacts />
          </Route>
          <Route path="/seleccionar-vehiculo">
            <SelectVehicles />
          </Route>
          <Route path="/notificaciones/:id">
            <SingleNotification />
          </Route>
          <Route path="/notificaciones">
            <Notifications />
          </Route>
          <Route path="/ajustes">
            <Setting />
          </Route>
          <Route path="/cuenta">
            <Account />
          </Route>
          <Route path="/buzon">
            <Mailbox />
          </Route>
          <Route path="/recuperar-acceso">
            <ResetPassword />
          </Route>
          <Route path="/legal">
            <TermsAndConditions />
          </Route>
          <Route path="*">
            <Page404 />
          </Route>
        </Switch>
        <BottomNavigation />
      </Router>
    </>
  );
};

export default withRouter(Dashboard);
